import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MedconnectDevicesForm from '../components/MedconnectDevicesForm'
import { MedconnectDevice, MedconnectDevicesConfig, MedconnectDeviceValue, DEVICE_IMG } from '@/constants/medconnect-devices-types'
import { createDevice, deleteDevice, getConfig, restartDevice } from '@/core/classes/MedconnectDevicesAPI'
import MedconnectDevices from '@/components/ui/cards/MedconnectDevicesCard'
import { MedconnectDeviceCardProps } from '@/components/ui/cards/MedconnectDevicesCard/MedconnectDeviceCard'
import { Alert } from '@mui/material'

export default function MedconnectDevicesConfigurator() {
  const { t } = useTranslation()
  const [config, setConfig] = useState<MedconnectDevicesConfig | undefined>(undefined)

  const handleConfig = async () => {
    const config = await getConfig()
    if (!config) return
    setConfig(config)
  }

  const handleAddDevice = async (device: MedconnectDeviceValue) => {
    const config = await createDevice(device)
    if (!config) return
    setConfig(config)
  }

  const handleSubmit = (values: MedconnectDeviceValue) => {
    handleAddDevice(values)
  }

  const handleDeleteDevice = async (id: string) => {
    const config = await deleteDevice(id)
    if (!config) return
    setConfig(config)
  }

  const handleRestartDevice = async (id: string) => {
    const config = await restartDevice(id)
    if (!config) return
    setConfig(config)
  }

  const deviceProps = useMemo((): MedconnectDeviceCardProps[] => {
    // return devices from config under props format
    if (!config) return []
    if (!config.Devices) return []
    return config?.Devices.map((device: MedconnectDevice) => {
      return {
        ...device,
        restartDevice: () => {
          handleRestartDevice(device._id)
        },
        deleteDevice: () => {
          handleDeleteDevice(device._id)
        },
        logoSrc: DEVICE_IMG[device.name],
        connectDevice: () => {},
        isLocal: true,
      }
    })
  }, [config])

  useEffect(() => {
    handleConfig()
  }, [])

  if (!config?.INSTALLER_NAME) return <Alert severity="info">{t('page.configuration.MedconnectDevice.noConnector')}</Alert>

  return (
    <>
      <MedconnectDevicesForm onSubmit={handleSubmit} isSubmitting={false} />
      <MedconnectDevices devices={deviceProps} />
    </>
  )
}
